import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate } from "react-router-dom";
import debounce from 'lodash/debounce';
import WarehouseAssortmentListComponent from "./component";

const WarehouseAssortmentListContainer = (props) => {
  const navigate = useNavigate();
  const [assortmentWarehouseMetaDataList, setAssortmentWarehouseMetaDataList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const handleWarehouseClick = (reference_id) => {
    navigate(`/home/assortment/assortmentwarehousecreation/${reference_id}`);
  };

  useEffect(() => {
    handleAssortmentWarehouseList();
  }, []);

  const handleAssortmentWarehouseList = debounce((query = "") => {
    setLoading(true);
    props.getDataFromAPI(
      `/partner/api/v1/assortment/warehouse/metadata`,
      "GET",
      undefined,
      (response) => {
        setAssortmentWarehouseMetaDataList(response || []);
        setLoading(false);
      },
      (err) => {
        console.error("API Error:", err);
        setError(err.message || "Failed to load warehouse data");
        setLoading(false);
      }
    );
  }, 300);

  return (
    <WarehouseAssortmentListComponent
      assortmentWarehouseMetaDataList={assortmentWarehouseMetaDataList}
      handleWarehouseClick={handleWarehouseClick}
      loading={loading}
      error={error}
    />
  );
};

function mapStateToProps(props) {
  return {
    props
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(WarehouseAssortmentListContainer);